import typeLabel from '@/constants/ActivityTypeLabelsStudents';
import GameButton from '@/shared/GameComponents/UI/GameAnswerButton/GameButton';
import useCoverMenu from './useCoverMenu.hook';
import React from 'react';
import { sortImagesAssetsFolder } from '@/shared/Activities/RealTimeActivity/Players/SortImagesActivity/sortImages.utils';
import GameCoverMenu from '@/shared/GameComponents/UI/CoverMenu/CoverMenu';

export default function CoverMenu({
  activity,
  activityConf,
  gameActions,
  starting,
}) {
  const { state, actions } = useCoverMenu({
    activityConf,
    gameActions,
  });

  return (
    <GameCoverMenu
      activity={activity}
      coverImageSrc={`${sortImagesAssetsFolder}/${activity.data.folder}/${activity.data.cover}`}
    >
      {
        {
          TYPE: ['training', 'conceptQuest'].map((type) => (
            <React.Fragment key={type}>
              <GameButton
                type="primary"
                onClick={() =>
                  gameActions.setGameConf({ miniactivityType: type })
                }
              >
                {typeLabel('game', 'sortImages', type)}
              </GameButton>
              {type == 'training' ? (
                <p className="option-info">Listen, Read, View!</p>
              ) : (
                <p className="option-info">Listen, Think, Match!</p>
              )}
            </React.Fragment>
          )),
          START: (
            <>
              <GameButton
                type="primary"
                onClick={actions.startGame}
                loading={starting}
              >
                START
              </GameButton>
              {activityConf.menu ? (
                <GameButton
                  type="secondary"
                  onClick={() => {
                    gameActions.setGameConf({
                      miniactivityType: null,
                    });
                  }}
                >
                  BACK
                </GameButton>
              ) : null}
            </>
          ),
        }[state.screen]
      }
    </GameCoverMenu>
  );
}
